import {isPlatformBrowser} from '@angular/common';
import {AfterViewInit, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {
  CmsFlexComponentData
} from '@app/checkout/order-confirmation/order-confirmation-list-item/order-confirmation-order-item.model';
import {MultiCurrencyErrorInfo} from '@app/model/multi-currency-cart-error-info.model';
import {ComponentService} from '@app/services/component.service';
import {DcpActiveCartService} from '@app/services/dcp-active-cart.service';
import {IFrameMessageService} from '@app/services/iframe/iframe-message.service';
import {FetchTextsComponent} from '@app/shared/fetch-texts/fetch-texts.component';
import {ConfiguratorUriParameterService, CLOSE_EVENT, LOADING} from '@dcp/configurator';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';
import {CmsComponentData} from '@spartacus/storefront';
import {Subscription} from 'rxjs';
import {Sap4MeHideHeaderService} from '@app/services/sap4me-hide-header.service';

@UntilDestroy()
@Component({
  selector: 'dcp-configurator',
  templateUrl: './configurator.component.html',
  styleUrls: ['./configurator.component.scss']
})
export class ConfiguratorComponent extends FetchTextsComponent implements OnInit, AfterViewInit, OnDestroy {
  errorInfo: MultiCurrencyErrorInfo;
  configureServiceError: boolean = false;
  heading: string;
  cartEntry: OrderEntry;
  cartEntrySubscription: Subscription = Subscription.EMPTY;
  modalMode: string;

  constructor(
    protected dcpActiveCartService: DcpActiveCartService,
    protected cmsData: CmsComponentData<CmsFlexComponentData>,
    protected componentService: ComponentService,
    protected cdr: ChangeDetectorRef,
    protected configuratorUriParameterService: ConfiguratorUriParameterService,
    private iFrameMessageService: IFrameMessageService,
    private sap4meHideHeaderService: Sap4MeHideHeaderService,
    @Inject(PLATFORM_ID) public platformId: object,
  ) {
    super(
      cmsData,
      componentService,
      cdr,
    );
  }

  ngOnInit() {
    this.cartEntrySubscription = this.dcpActiveCartService.getOrderEntries().pipe(untilDestroyed(this)).subscribe(
      orderEntries => {
        this.cartEntry = orderEntries.find((entry) => this.doesActiveRouteMatchProductInEntry(entry));
      }
    );
    setTimeout(() => {
      this.fetchComponentData();
    });
    this.iFrameMessageService.getActiveModalMode().pipe(untilDestroyed(this)).subscribe((value) => {
      if (value === 'modal') {
        this.sap4meHideHeaderService.hideHeader();
      }
      this.modalMode = value;
    });
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId) && this.iFrameMessageService.isIframe()) {
      this.iFrameMessageService.postMessage({eventId: LOADING});
    }
  }

  setHeading(heading: string) {
    this.heading = heading;
  }

  closeModal() {
    if (isPlatformBrowser(this.platformId) && this.iFrameMessageService.isIframe()) {
      this.iFrameMessageService.postMessage({eventId: CLOSE_EVENT});
    }
  }

  doesActiveRouteMatchProductInEntry(entry: OrderEntry): boolean {
    return entry.product.supplierAlternativeAID ?
      entry.product.supplierAlternativeAID === this.configuratorUriParameterService.getProduct() : false;
  }

  ngOnDestroy() {
    this.cartEntrySubscription.unsubscribe();
  }

  addMultiCurrencyErrorInfo(errorInfo: MultiCurrencyErrorInfo) {
    this.errorInfo = errorInfo;
    this.setHeading('configurator.addLicenses');
  }

  processConfigureServiceError(e: boolean): void {
    this.configureServiceError = e;
  }
}
